export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/overlays_screen_packs.99e0767.svg";